import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-deployment-frequency-report.issues-per-deployment-chart.chart-title',
		defaultMessage: 'Batch Size',
		description: 'Title of a chart that shows number of issues per deployment.',
	},
	titleHelpTooltip: {
		id: 'software-deployment-frequency-report.issues-per-deployment-chart.title-help-tooltip',
		defaultMessage:
			"Analyze your issues per deployment over the 12-week median and how it impacts your team's deployment frequency.",
		description:
			'The message that is displayed when the mouse is hovered on the question mark beside the non-production deployment frequency line chart title.',
	},
	titleHelpTooltipIssueTermRefresh: {
		id: 'software-deployment-frequency-report.issues-per-deployment-chart.title-help-tooltip-issue-term-refresh',
		defaultMessage:
			"Analyze your work items per deployment over the 12-week median and how it impacts your team's deployment frequency.",
		description:
			'The message that is displayed when the mouse is hovered on the question mark beside the non-production deployment frequency line chart title.',
	},
});
